import type { ReactNode } from 'react'
import './EmptyState.css'

export type EmptyStateProps = {
  /** Decorative line icon in the soft circular tile. */
  icon?: ReactNode
  title: string
  body?: string
  /** Optional action (e.g. a Button) below the copy. */
  action?: ReactNode
}

export function EmptyState({ icon, title, body, action }: EmptyStateProps) {
  return (
    <div className="ui-empty-state">
      {icon && (
        <span className="ui-empty-state__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      <h2 className="ui-empty-state__title">{title}</h2>
      {body && <p className="ui-empty-state__body">{body}</p>}
      {action && <div className="ui-empty-state__action">{action}</div>}
    </div>
  )
}
